/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type AffirmPromo_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AffirmPromo_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AffirmDisplay_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Affirm/__generated__/AffirmPromo_viewer.graphql.js